import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings-btn rtl-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("a", {
      href: "https://wa.me/447429916178",
      target: "_blank",
      rel: "noopener noreferrer",
      class: "whatsapp-btn",
      "aria-label": "WhatsApp"
    }, [
      _createElementVNode("i", { class: "ri-whatsapp-fill" })
    ], -1)
  ]))]))
}